import { put, select, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { fetchStart, fetchSuccess } from '..';
import { fetchPersonalTasks } from '../actions';
function* fetchPersonalTasksSaga() {
    try {
        yield put(fetchStart());
        // personalTasks is already in the store via init api call. No need to fetch again
        // use a selector instead of the api call to get the data
        const data = yield select((state)=>{
            var _state_personalTasks;
            return (state === null || state === void 0 ? void 0 : (_state_personalTasks = state.personalTasks) === null || _state_personalTasks === void 0 ? void 0 : _state_personalTasks.data) || [];
        });
        yield put(fetchSuccess(data));
    } catch (error) {
        logger.error('getPersonalTasks', {
            error
        });
    // TODO::
    }
}
export function* watchFetchPersonalTasksSaga() {
    yield takeLatest(fetchPersonalTasks.type, fetchPersonalTasksSaga);
}
